<template>
    <div>
        <div
            ref="new-shape-collapsibles"
            id="accordion_new_zone"
            class="lb-accordion pb-6"
        >
            <!-- General info section -->
            <article class="message">
                <!--header section -->
                <div class="message-header has-text-black">
                    <a
                        href="#accordion_new_zone-information"
                        data-action="collapse"
                        style="width: 100%"
                    >
                        <nav class="level">
                            <div class="level-left">
                                <div class="level-item">
                                    <div class="level-item section-title">
                                        <span class="icon-text">
                                            <span class="icon is-medium">
                                                <i
                                                    class="
                                                        mdi
                                                        mdi-24px
                                                        mdi-information-outline
                                                    "
                                                ></i>
                                            </span>
                                            <span class="ml-2 mt-1">
                                                {{
                                                    $t(
                                                        'project.settings.general_information'
                                                    )
                                                }}</span
                                            >
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="level-right">
                                <div class="level-item">
                                    <span
                                        ref="information-icon"
                                        class="icon is-medium"
                                    >
                                        <i class="fas fa-caret-down"></i>
                                    </span>
                                </div>
                            </div>
                        </nav>
                    </a>
                </div>

                <!-- body section -->
                <div
                    id="accordion_new_zone-information"
                    class="message-body new-zone is-collapsible"
                    data-parent="accordion_new_zone"
                    data-allow-multiple="false"
                >
                    <div class="message-body-content px-4 py-4">
                        <!-- helper section -->
                        <div class="is-flex is-flex-direction-row-reverse">
                            <span
                                :data-tippy-content="
                                    $t('Zone.general_info_helper')
                                "
                                class="
                                    icon
                                    is-small
                                    has-text-grey-light
                                    creation-helper
                                "
                                ><i
                                    class="mdi mdi-24px mdi-help-circle-outline"
                                ></i
                            ></span>
                        </div>

                        <!-- content section -->
                        <div
                            class="field mb-5"
                            v-if="model.title || content.title"
                        >
                            <label class="label">{{
                                $t('Object.title_label')
                            }}</label>
                            <div class="control">
                                <textarea
                                    v-model="content.title"
                                    class="textarea"
                                />
                            </div>
                        </div>
                        <div
                            class="field mb-5"
                            v-if="model.description || content.description"
                        >
                            <label class="label">{{
                                $t('Object.description_label')
                            }}</label>
                            <div class="control">
                                <input-rich-text
                                    class="lb-bordered"
                                    v-if="model.description"
                                    v-model="content.description"
                                    :editable="true"
                                    :placeholder="descriptionPlaceholder"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </article>

            <!-- shape section -->
            <article class="message">
                <!-- header section -->
                <div class="message-header has-text-black">
                    <a
                        href="#accordion_new_zone-shape"
                        data-action="collapse"
                        style="width: 100%"
                        :ref="'shape'"
                    >
                        <nav class="level">
                            <div class="level-left">
                                <div class="level-item">
                                    <div class="level-item section-title">
                                        <span class="icon-text">
                                            <span class="icon is-medium">
                                                <i
                                                    class="
                                                        mdi
                                                        mdi-24px
                                                        mdi-shape-plus
                                                    "
                                                ></i>
                                            </span>
                                            <span class="ml-2 mt-1">
                                                {{ $t('Zone.shape') }}</span
                                            >
                                        </span>
                                    </div>
                                </div>
                            </div>
                            
                        </nav>
                    </a>
                </div>

                <!-- body section -->
                <div
                    id="accordion_new_zone-shape"
                    class="message-body new-zone is-collapsible"
                    data-parent="accordion_new_zone"
                    data-allow-multiple="false"
                >
                    <div class="message-body-content px-4 py-4">
                        <!-- helper section -->
                        <div class="is-flex is-flex-direction-row-reverse">
                            <span
                                :data-tippy-content="
                                    $t('Zone.shape_selector_helper')
                                "
                                class="
                                    icon
                                    is-small
                                    has-text-grey-light
                                    creation-helper
                                "
                                ><i
                                    class="mdi mdi-24px mdi-help-circle-outline"
                                ></i
                            ></span>
                        </div>

                        <!-- zone shape selector -->
                        <div class="pb-4 pt-2">
                            <label class="label">{{
                                $t('Zone.shape_selector')
                            }}</label>

                            <div class="columns is-mobile is-vcentered">
                                <div class="column is-3 pr-0">
                                    <button
                                        class="
                                            button
                                            is-fullwidth
                                            selector-left
                                        "
                                        @click="addCircle"
                                        :disabled="shapeAdded"
                                        :class="{
                                            'is-selected is-primary':
                                                activeShapeType == 'circle',
                                        }"
                                    >
                                        <i
                                            class="
                                                mdi
                                                mdi-24px
                                                mdi-shape-circle-plus
                                            "
                                        ></i>
                                    </button>
                                </div>
                                <div class="column is-3 px-0">
                                    <button
                                        class="
                                            button
                                            is-fullwidth
                                            selector-middle
                                        "
                                        @click="addPolygon"
                                        :disabled="shapeAdded"
                                        :class="{
                                            'is-selected is-primary':
                                                activeShapeType == 'polygon',
                                        }"
                                    >
                                        <i
                                            class="
                                                mdi
                                                mdi-24px
                                                mdi-shape-polygon-plus
                                            "
                                        ></i>
                                    </button>
                                </div>
                                <div class="column is-3 px-0">
                                    <button
                                        class="
                                            button
                                            is-fullwidth
                                            selector-middle
                                        "
                                        @click="addRectangle"
                                        :disabled="shapeAdded"
                                        :class="{
                                            'is-selected is-primary':
                                                activeShapeType == 'rectangle',
                                        }"
                                    >
                                        <i
                                            class="
                                                mdi
                                                mdi-24px
                                                mdi-shape-rectangle-plus
                                            "
                                        ></i>
                                    </button>
                                </div>
                                <div class="column is-3 pl-0">
                                    <button
                                        class="
                                            button
                                            is-danger is-fullwidth
                                            selector-right
                                        "
                                        @click="removeShape"
                                        :disabled="!shapeAdded"
                                    >
                                        <i
                                            class="mdi mdi-24px mdi-close-thick"
                                        ></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </article>

            <!-- on_enter section -->
            <article class="message">
                <!-- header section -->
                <div class="message-header has-text-black">
                    <a
                        href="#accordion_new_zone-on-enter"
                        data-action="collapse"
                        style="width: 100%"
                        :ref="'on-enter'"
                    >
                        <nav class="level">
                            <div class="level-left">
                                <div class="level-item">
                                    <div class="level-item section-title">
                                        <span class="icon-text">
                                            <span class="icon is-medium">
                                                <i
                                                    class="
                                                        mdi
                                                        mdi-24px
                                                        mdi-location-enter
                                                    "
                                                ></i>
                                            </span>
                                            <span class="ml-2 mt-1">
                                                {{ $t('Zone.on_enter') }}</span
                                            >
                                        </span>
                                    </div>
                                </div>
                            </div>
                            
                        </nav>
                    </a>
                </div>

                <!-- body section -->
                <div
                    id="accordion_new_zone-on-enter"
                    class="message-body new-zone is-collapsible"
                    data-parent="accordion_new_zone"
                    data-allow-multiple="false"
                >
                    <div class="message-body-content px-4 py-4">
                        <!-- helper section -->
                        <div class="is-flex is-flex-direction-row-reverse">
                            <span
                                :data-tippy-content="$t('Zone.on_enter_helper')"
                                class="
                                    icon
                                    is-small
                                    has-text-grey-light
                                    creation-helper
                                "
                                ><i
                                    class="mdi mdi-24px mdi-help-circle-outline"
                                ></i
                            ></span>
                        </div>

                        <!-- event activation switch -->
                        <div class="columns is-mobile is-vcentered px-0 pt-4">
                            <div class="column is-9">
                                <label class="label">{{
                                    $t('Zone.on_enter_activate')
                                }}</label>
                            </div>

                            <div class="column is-3 has-text-right">
                                <label class="switch">
                                    <input
                                        v-model="onEnterActivated"
                                        type="checkbox"
                                    />
                                    <span class="slider round"></span>
                                </label>
                            </div>
                        </div>

                        <!-- event object selector -->
                        <div v-if="onEnterActivated">
                            <div class="columns is-mobile is-vcentered">
                                <div class="column is-6 pr-0">
                                    <button
                                        @click="activeEnterObject = 'object'"
                                        class="
                                            button
                                            is-fullwidth
                                            selector-left
                                        "
                                        :class="{
                                            'is-selected is-primary':
                                                activeEnterObject == 'object',
                                        }"
                                    >
                                        {{ $t('Zone.show_an_object') }}
                                    </button>
                                </div>
                                <div class="column is-6 pl-0">
                                    <button
                                        @click="activeEnterObject = 'question'"
                                        class="
                                            button
                                            is-fullwidth
                                            selector-right
                                        "
                                        :class="{
                                            'is-selected is-primary':
                                                activeEnterObject == 'question',
                                        }"
                                    >
                                        {{ $t('Zone.ask_a_question') }}
                                    </button>
                                </div>
                            </div>

                            <!-- event available objects list -->
                            <div v-if="activeEnterObject == 'object'">
                                <div
                                    class="select is-fullwidth"
                                    v-if="objects.lenght"
                                >
                                    <select>
                                        <option>Select object</option>

                                        <!--<option>object 1</option>
                                        <option>object 2</option>
                                        <option>object 3</option>-->
                                    </select>
                                </div>
                                <div v-else>
                                    <article class="message is-warning">
                                        <div class="message-body">
                                            {{
                                                $t('Zone.no_objects_available')
                                            }}
                                        </div>
                                    </article>
                                </div>
                            </div>

                            <!-- event available questions list -->
                            <div v-else-if="activeEnterObject == 'question'">
                                <div
                                    class="select is-fullwidth"
                                    v-if="questions.lenght"
                                >
                                    <select>
                                        <option>Select question</option>
                                        <!-- <option>question 1</option>
                                        <option>question 2</option>
                                        <option>question 3</option>-->
                                    </select>
                                </div>
                                <div v-else>
                                    <article class="message is-warning">
                                        <div class="message-body">
                                            {{
                                                $t(
                                                    'Zone.no_questions_available'
                                                )
                                            }}
                                        </div>
                                    </article>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </article>

            <!-- on_leave section -->
            <article class="message">
                <!-- header section -->
                <div class="message-header has-text-black">
                    <a
                        href="#accordion_new_zone-on-leave"
                        data-action="collapse"
                        style="width: 100%"
                        :ref="'on-leave'"
                    >
                        <nav class="level">
                            <div class="level-left">
                                <div class="level-item">
                                    <div class="level-item section-title">
                                        <span class="icon-text">
                                            <span class="icon is-medium">
                                                <i
                                                    class="
                                                        mdi
                                                        mdi-24px
                                                        mdi-location-exit
                                                    "
                                                ></i>
                                            </span>
                                            <span class="ml-2 mt-1">
                                                {{ $t('Zone.on_leave') }}</span
                                            >
                                        </span>
                                    </div>
                                </div>
                            </div>
                            
                        </nav>
                    </a>
                </div>

                <!-- body section -->
                <div
                    id="accordion_new_zone-on-leave"
                    class="message-body new-zone is-collapsible"
                    data-parent="accordion_new_zone"
                    data-allow-multiple="false"
                >
                    <div class="message-body-content px-4 py-4">
                        <!-- helper section -->
                        <div class="is-flex is-flex-direction-row-reverse">
                            <span
                                :data-tippy-content="$t('Zone.on_leave_helper')"
                                class="
                                    icon
                                    is-small
                                    has-text-grey-light
                                    creation-helper
                                "
                                ><i
                                    class="mdi mdi-24px mdi-help-circle-outline"
                                ></i
                            ></span>
                        </div>

                        <!-- event activation switch -->
                        <div class="columns is-mobile is-vcentered px-0 pt-4">
                            <div class="column is-9">
                                <label class="label">{{
                                    $t('Zone.on_leave_activate')
                                }}</label>
                            </div>

                            <div class="column is-3 has-text-right">
                                <label class="switch">
                                    <input
                                        v-model="onLeaveActivated"
                                        type="checkbox"
                                    />
                                    <span class="slider round"></span>
                                </label>
                            </div>
                        </div>

                        <!-- event object selector -->
                        <div v-if="onLeaveActivated">
                            <div class="columns is-mobile is-vcentered">
                                <div class="column is-6 pr-0">
                                    <button
                                        @click="activeLeaveObject = 'object'"
                                        class="
                                            button
                                            is-fullwidth
                                            selector-left
                                        "
                                        :class="{
                                            'is-selected is-primary':
                                                activeLeaveObject == 'object',
                                        }"
                                    >
                                        {{ $t('Zone.show_an_object') }}
                                    </button>
                                </div>
                                <div class="column is-6 pl-0">
                                    <button
                                        @click="activeLeaveObject = 'question'"
                                        class="
                                            button
                                            is-fullwidth
                                            selector-right
                                        "
                                        :class="{
                                            'is-selected is-primary':
                                                activeLeaveObject == 'question',
                                        }"
                                    >
                                        {{ $t('Zone.ask_a_question') }}
                                    </button>
                                </div>
                            </div>

                            <!-- event available objects list -->
                            <div v-if="activeLeaveObject == 'object'">
                                <div
                                    class="select is-fullwidth"
                                    v-if="objects.lenght"
                                >
                                    <select>
                                        <option>Select object</option>

                                        <!--<option>object 1</option>
                                        <option>object 2</option>
                                        <option>object 3</option>-->
                                    </select>
                                </div>
                                <div v-else>
                                    <article class="message is-warning">
                                        <div class="message-body">
                                            {{
                                                $t('Zone.no_objects_available')
                                            }}
                                        </div>
                                    </article>
                                </div>
                            </div>

                            <!-- event available questions list -->
                            <div v-else-if="activeLeaveObject == 'question'">
                                <div
                                    class="select is-fullwidth"
                                    v-if="questions.lenght"
                                >
                                    <select>
                                        <option>Select question</option>
                                        <!-- <option>question 1</option>
                                        <option>question 2</option>
                                        <option>question 3</option>-->
                                    </select>
                                </div>
                                <div v-else>
                                    <article class="message is-warning">
                                        <div class="message-body">
                                            {{
                                                $t(
                                                    'Zone.no_questions_available'
                                                )
                                            }}
                                        </div>
                                    </article>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </article>

            <!-- tags section -->
            <article class="message">
                <!-- header section -->
                <div class="message-header has-text-black">
                    <a
                        href="#accordion_new_zone-tags"
                        data-action="collapse"
                        style="width: 100%"
                        :ref="'tags'"
                    >
                        <nav class="level">
                            <div class="level-left">
                                <div class="level-item">
                                    <div class="level-item section-title">
                                        <span class="icon-text">
                                            <span class="icon is-medium">
                                                <i
                                                    class="
                                                        mdi
                                                        mdi-24px
                                                        mdi-tag-multiple
                                                    "
                                                ></i>
                                            </span>
                                            <span class="ml-2 mt-1">
                                                {{ $t('Object.tags') }}</span
                                            >
                                        </span>
                                    </div>
                                </div>
                            </div>
                            
                        </nav>
                    </a>
                </div>

                <!-- body section -->
                <div
                    id="accordion_new_zone-tags"
                    class="message-body new-zone is-collapsible"
                    data-parent="accordion_new_zone"
                    data-allow-multiple="false"
                >
                    <div class="message-body-content px-4 py-4">
                        <!-- helper section -->
                        <div class="is-flex is-flex-direction-row-reverse">
                            <span
                                :data-tippy-content="
                                    $t('Object.object_tags_description')
                                "
                                class="
                                    icon
                                    is-small
                                    has-text-grey-light
                                    creation-helper
                                "
                                ><i
                                    class="mdi mdi-24px mdi-help-circle-outline"
                                ></i
                            ></span>
                        </div>

                        <!-- content section -->
                        <label class="label">{{
                            $t('Object.tags_label')
                        }}</label>
                        <l-project-object-input-tags v-model="content.tags" />
                    </div>
                </div>
            </article>
        </div>

        <!-- errors section -->
        <div v-if="errorsOnSave" class="validationErrors px-5">
            <div class="notification is-danger is-light">
                <button class="delete" @click="errorsOnSave = false"></button>
                <p class="has-text-weight-bold is-size-6 pb-2">
                    {{ $t('Zone.errors_on_save') }}
                </p>
                <p class="is-size-6">
                    {{ $t('Zone.errors_on_save_desc') }}
                </p>
                <br />
                <p
                    class="is-size-6 has-text-italic"
                    v-for="(error, index) in objectErrors"
                    :key="index"
                >
                    - {{ error }}
                </p>
            </div>
        </div>

        <!-- action buttons -->
        <div
            class="
                columns
                is-mobile
                action-buttons
                px-0
                py-0
                has-background-white
            "
        >
            <div class="column is-6 px-0 py-0">
                <button
                    v-t="'cancel'"
                    class="
                        button
                        is-black is-uppercase
                        has-text-weight-bold
                        is-fullwidth is-size-6 is-radiusless
                    "
                    @click="discardUnsavedChanges"
                />
            </div>
            <div class="column is-6 px-0 py-0">
                <button
                    v-t="'Buttons.save'"
                    :class="{ 'is-loading': saving }"
                    class="
                        button
                        is-primary is-uppercase
                        has-text-weight-bold
                        is-fullwidth is-size-6 is-radiusless
                    "
                    @click="validateAndSave"
                />
            </div>
        </div>
    </div>
</template>

<script>
import bulmaCollapsible from '@creativebulma/bulma-collapsible';
import InputRichText from '@/components/InputRichText';
import _ from 'underscore';
import tippy, { createSingleton } from 'tippy.js';
import LProjectObjectInputTags from '@/components/LProjectObjectInputTags';

//import from 'search-osm-batch'
export default {
    name: 'LProjectZone',
    components: {
        InputRichText,
        LProjectObjectInputTags,
    },
    props: {
        content: {
            type: Object,
            default() {
                return {};
            },
        },
        model: {
            type: Object,
            default() {
                return {};
            },
        },
        activeShape: {
            type: Object,
            default() {
                return {};
            },
        },
    },
    data() {
        return {
            showModalPreview: false,
            previewType: undefined,
            previewData: undefined,

            showPreviewModal: false,

            saving: false,
            originalContent: {},

            objectErrors: {},
            errorsOnSave: false,
            activeShapeType: '',
            activeEnterObject: '',
            activeLeaveObject: '',
            onEnterActivated: false,
            onLeaveActivated: false,
        };
    },
    computed: {
        hasAccess() {
            if (this.isCreation) {
                return true;
            }
            return this.content.accessLevel == 'administrator';
        },
        isLoggedIn() {
            return this.$store.getters.isLoggedIn;
        },

        descriptionPlaceholder() {
            if (
                this.$store.getters.project.type == 'treasurehunt' &&
                this.$store.getters.projectContent.length == 1
            ) {
                return this.$t('creation.treasurehunt_description_hint');
            }
            return '';
        },
        hasChanges() {
            return this.content !== this.originalContent;
        },
        shapeAdded() {
            return Object.keys(this.activeShape).length > 0;
        },
        questions() {
            return _.filter(this.$store.getters.projectContent, (object) => {
                return object.type == 'question';
            });
        },
        objects() {
            return _.filter(this.$store.getters.projectContent, (object) => {
                return object.type == 'object';
            });
        },
    },
    watch: {
        
    },
    mounted() {
        const newShapeCollapsibles = bulmaCollapsible.attach('.new-zone', {allowMultiple: false});
        const newShapeTippyInstances = tippy('[data-tippy-content]');
        const newShapeSingleton = createSingleton(newShapeTippyInstances, {
            delay: 100,
            moveTransition: 'transform 0.2s ease-out',
            placement: 'right',
            theme: 'tippylabyloksolid',
            allowHTML: true,
            trigger: 'click',
            animation: 'shift-away',
            offset: [0, 20],
        });

        this.originalContent = { ...this.content };
        if (this.originalContent.shape) {
            this.activeShapeType = this.originalContent.shape.type;
        }
        // console.log(localStorage.getItem('token'));
        // console.log(this.model, this.content);
    },
    beforeDestroy() {
        //this.$refs['imagesDropzone'].
    },
    destroyed() {},
    methods: {
        

        validateAndSave() {
            /*console.log(
                this.activeShape,
                Object.keys(this.activeShape).length,
                this.activeShapeType
            );*/
            if (!this.content.title || !this.content.title.length) {
                this.objectErrors['title'] = this.$t(
                    `Zone.missing_title_value`
                );
            } else {
                delete this.objectErrors['title'];
            }

            if (
                !this.activeShape ||
                Object.keys(this.activeShape).length === 0 ||
                !this.activeShapeType
            ) {
                this.objectErrors['shape'] = this.$t(
                    `Zone.missing_shape_value`
                );
            } else {
                delete this.objectErrors['shape'];
            }

            if (
                this.onEnterActivated &&
                (!this.content.events || !this.content.events.onEnter)
            ) {
                this.objectErrors['on_enter'] = this.$t(
                    `Zone.missing_on_enter_value`
                );
            } else {
                delete this.objectErrors['on_enter'];
            }

            if (
                this.onLeaveActivated &&
                (!this.content.events || !this.content.events.onLeave)
            ) {
                this.objectErrors['on_leave'] = this.$t(
                    `Zone.missing_on_leave_value`
                );
            } else {
                delete this.objectErrors['on_leave'];
            }

            // console.log(this.objectErrors);
            const isValid = Object.keys(this.objectErrors).length === 0;
            if (isValid) {
                // console.log('content to save', this.content);
                if (!this.content.shape) {
                    this.content.shape = {};
                }
                this.content.shape.type = this.activeShapeType;
                let newGeo = this.activeShape.toGeoJSON();
                if (this.activeShapeType == 'circle') {
                    // console.log(newGeo);
                    this.content.shape.radius = this.activeShape.getRadius(); //this.activeShape._mRadius;
                    this.content.shape.coordinates =
                        newGeo.geometry.coordinates;
                    /*this.content.shape.coordinates = {
                        ...this.activeShape._latlng,
                    };
                    delete this.content.shape.coordinates.__vertex;*/
                } else {
                    /*this.content.shape.coordinates =
                        this.activeShape.getLatLngs();*/
                    this.content.shape.coordinates =
                        newGeo.geometry.coordinates;
                    // console.log(newGeo);
                }
                // console.log('zone', this.content.shape);
                this.$emit('save');
                // console.log('is valid object');
            } else {
                this.errorsOnSave = true;
            }
        },

        cleanCoordinates(coordinatesArray) {
            // console.log('cleaning', coordinatesArray);
            for (let coordinates in coordinatesArray) {
                // console.log(coordinates);
                delete coordinates.__vertex;
            }
            return coordinatesArray;
        },

        showPreview() {
            this.showPreviewModal = true;
        },
        discardUnsavedChanges() {
            // console.log('discard');
            this.$emit('cancel');
        },
        addCircle() {
            // console.log('start event');
            this.activeShapeType = 'circle';
            this.$emit('drawCircle');
        },
        addPolygon() {
            this.activeShapeType = 'polygon';
            this.$emit('drawPolygon');
        },
        addRectangle() {
            this.activeShapeType = 'rectangle';
            this.$emit('drawRectangle');
        },
        removeShape() {
            this.activeShapeType = '';
            this.$emit('removeShape');
        },
    },
};
</script>

<style scoped>
@import '~tippy.js/animations/shift-away.css';
@import '../assets/css/tippylabyloksolid.css';
textarea {
    min-height: 3rem !important;
    resize: vertical;
}
.message {
    background-color: transparent;
    border-radius: 0;
    font-size: 1rem;
    margin-bottom: 0;
}
.message-header {
    border-radius: 0;
    padding-right: 0;
    background-color: #f4f4f4;
    border-bottom: 1px solid #d2d2d2;
}
.lb-accordion {
    overflow-y: auto;
    max-height: calc(100vh - 13rem);
    overflow-x: hidden;
}
.message
    a:not(.button):not(.lb-button):not(.lb-toolbar-button_images):not(.lb-toolbar-button_video):not(.lb-toolbar-button_files):not(.lb-toolbar-button_audio):not(.lb-toolbar-button_url):not(.lb-toolbar-button_location):not(.lb-toolbar-button_tags):not(.lb-toolbar-button_question):not(.lb-toolbar-button_object):not(.lb-toolbar-button_point):not(.lb-delete-media):not(.lb-answer):not(.lb-multiple-answer):not(.tag):not(.lb-bain-tag-functional):not(.lb-bain-tag-emotional):not(.lb-bain-tag-life-changer):not(.lb-bain-tag-social-impact):not(.lb-role-tag_administrator):not(.lb-role-tag_teacher):not(.lb-role-tag_student):not(.lb-role-tag_coordinator):not(.lb-role-tag_participant):not(.lb-role-tag_facilitator):not(.lb-status-tag_active):not(.lb-status-tag_inactive):not(.lb-status-tag_invited):not(.dropdown-item) {
    text-decoration: none;
}
.message-body.is-collapsible {
    overflow-x: hidden;
}
.action-buttons {
    position: absolute;
    bottom: 11px;
    width: 100%;
    left: 10px;
}
.action-buttons button {
    height: 60px;
}

.lb-bordered {
    border: 1px solid #dbdbdb;
    border-radius: 4px;
    box-shadow: inset 0 0.0625em 0.125em rgb(74 74 74 / 5%);
}

.lb-bordered:hover {
    border: 1px solid #b5b5b5;
}

.lb-bordered:focus-within {
    border: 1px solid #4a4a4a;
}

.lb-bordered /deep/ .buttons {
    border-radius: 4px 4px 0 0;
    margin-bottom: 0;
}
.lb-bordered /deep/ .editor__content {
    padding: 0.75rem;
}
.lb-bordered /deep/ .is-empty.editor-empty {
    display: none;
}
.is-borderless-left {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    border-left: 0;
}
.is-radiusless-right {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
}

.creation-helper:hover {
    cursor: pointer;
}
.creation-helper:hover i {
    color: #0074d9;
}

.validationErrors {
    position: absolute;
    z-index: +1;
    top: 20%;
}

.validationErrors .notification {
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

.button.selector-left {
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
}

.button.selector-right {
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
}

.button.selector-middle {
    border-radius: 0;
}
</style>
